
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M55.579 0H4.421C1.989 0 0 1.981 0 4.402v50.94c0 2.42 1.974 4.402 4.421 4.402h51.158c2.431 0 4.421-1.966 4.421-4.403V4.402C60 1.965 58.01 0 55.579 0zm1.263 55.341c0 .692-.568 1.258-1.263 1.258H40.926V38h7.248l1.042-8.364h-8.29v-5.393c0-2.437.6-4.103 4.106-4.103h4.547v-7.562c-.774-.095-3.458-.268-6.553-.268-6.442 0-10.831 3.868-10.831 11.053v6.257h-7.342v8.364h7.342v18.6H4.42a1.264 1.264 0 01-1.263-1.258V4.386c0-.691.568-1.257 1.263-1.257h51.158c.695 0 1.263.566 1.263 1.257v50.955z"}})])
          )
        }
      }
    